import styled from '@emotion/styled'

export type PillVariant =
	| 'error'
	| 'green'
	| 'info'
	| 'primary'
	| 'reversed'
	| 'warning'

const StatusPillContainer = styled.div`
	border-radius: 22.5px;
	padding: 0.125rem 0.5rem;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-weight: 500;

	${({ theme }) =>
		// TODO(pascal): Check with Jocelyn for the color codes left below: most of them were specified in the
		// mocks with names but either with conflicting colors (info), or with concepts that cannot be
		// changed easily (using core instead of green, using white for reversed).
		`
		&.error {
			border: solid 1px ${theme.palette.divider};
			color: ${theme.palette.fonts.error};
		}

		&.green {
			border: solid 1px ${theme.palette.divider};
			color: ${theme.palette.fonts.green};
		}

		&.info {
			color: ${theme.palette.info.contrastText};
			background: ${theme.palette.backgroundColors.info};
		}

		&.primary {
			border: solid 1px ${theme.palette.divider};
		}

		&.reversed {
			color: ${theme.palette.common.black};
			background: ${theme.palette.common.white};
		}

		&.warning {
			border: solid 1px ${theme.palette.divider};
			color: ${theme.palette.fonts.warning};
		}
	`}
`

export { StatusPillContainer }
